import { createServerFn } from "@tanstack/react-start";
import { getRequestHeader } from "@tanstack/react-start/server";
import { isProductionAnalyticsHost } from "./analytics";

/**
 * Cloudflare Pages serves a full copy of this site on
 * iraqcert-global-vision.pages.dev and on every branch/preview deployment.
 * Because every response here is server-rendered, the static `_headers`
 * file cannot noindex those copies — so the root route asks the server
 * which host it is answering for and adds a robots noindex meta on any
 * noncanonical host. Only iraqcert.com is indexable and measured. Production
 * builds on localhost and other staging domains must not contaminate GA4.
 */
export const isNonCanonicalHost = createServerFn({ method: "GET" }).handler(
  () => {
    const host = (getRequestHeader("host") ?? "").toLowerCase();
    return !isProductionAnalyticsHost(host);
  },
);
